import { render } from "./RecordButton.vue?vue&type=template&id=7aa16644"
import script from "./RecordButton.vue?vue&type=script&lang=js"
export * from "./RecordButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__